<app-data-set
	#dataSet
	[dataSource]="dataSource"
	defaultPresentationMode="table"
	[rowId]="rowId"
	firstColumnProperty="name"
>
	<app-data-set-toolbar>
		<div *appSearchActionGroup style="flex: 1">
			<app-data-set-search
				defaultFilterName="companyName"
				[defaultFilterLabel]="fieldLabels.companyName"
				[placeholder]="fieldLabels.defaultPlaceholder"
			>
				<div class="filter-grid" [style.--columns]="3">
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ fieldLabels.companyName }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('companyName')"
								(ngModelChange)="dataSet.filter('companyName', fieldLabels.companyName, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ fieldLabels.postalCode }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('postalCode')"
								(ngModelChange)="dataSet.filter('postalCode', fieldLabels.postalCode, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<!-- FIXME: FILTER FIXES -  Should use country code dropdown -->
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ fieldLabels.country }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('countryCode')"
								(ngModelChange)="dataSet.filter('countryCode', fieldLabels.country, $event)"
							/>
						</mat-form-field>
					</div>
				</div>
			</app-data-set-search>
		</div>

		@if (hasRequiredSc) {
			<div *appActionGroup>
				<app-data-set-action-button
					icon="add"
					label="Add"
					i18n-label="@@publicDirectory-add"
					(click)="navigateToAddNewCompany()"
					data-automation-id="public-directory-add-company-button"
				></app-data-set-action-button>
			</div>
		}
	</app-data-set-toolbar>

	<app-data-set-content>
		<app-data-set-table-view>
			@if (
				loadingService.isLoading(searchCompaniesPublicDirectoryLoadingKey) ||
				!finishedLoadingInitDataSearch ||
				loadingService.isLoading(getCompanyRelationshipsLoadingKey) ||
				!finishedLoadingInitDataCompanyRelationships
			) {
				<app-data-set-loading-row />
			}
			<table
				mat-table
				[dataSource]="dataSource"
				matSort
				[hidden]="
					loadingService.isLoading(searchCompaniesPublicDirectoryLoadingKey) ||
					!finishedLoadingInitDataSearch ||
					loadingService.isLoading(getCompanyRelationshipsLoadingKey) ||
					!finishedLoadingInitDataCompanyRelationships
				"
			>
				<tr class="mat-row" *matNoDataRow>
					<td class="mat-cell" [colSpan]="displayedColumns.length" i18n="@@dataSetTable-noRecordsFound">
						No records found.
					</td>
				</tr>

				<ng-container matColumnDef="companyName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@publicDirectory-displayCompanyName">
						Company Name
					</th>
					<td mat-cell *matCellDef="let row">{{ row.name }}</td>
				</ng-container>

				<ng-container matColumnDef="taxId">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@publicDirectory-displayTaxId">Tax ID</th>
					<td mat-cell *matCellDef="let row">{{ row.taxId }}</td>
				</ng-container>

				<ng-container matColumnDef="address">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@publicDirectory-displayAddress">Address</th>
					<td mat-cell *matCellDef="let row">
						<div style="display: flex; flex-direction: column">
							<div>{{ row.address.address1 }} {{ row.address.address2 }}</div>
							<div>
								{{ row.address.locality }}, {{ row.address.stateProvinceRegion }}
								{{ row.address.postalCode }}
							</div>
						</div>
					</td>
				</ng-container>

				@if (isOracle) {
					<ng-container matColumnDef="slugId">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@publicDirectory-slugId">SLUGID</th>
						<td mat-cell *matCellDef="let row">{{ row.slugId }}</td>
					</ng-container>
				}

				<ng-container matColumnDef="rowMenu">
					<th mat-header-cell *matHeaderCellDef></th>
					<td mat-cell *matCellDef="let row">
						@if (activeCompanyId !== row.id && isThereOptionsToDisplay(row.id)) {
							<app-data-set-table-menu
								[menu]="menu"
								[row]="row"
								[appHasSystemCapability]
								[hasOne]="['companyRelationshipManagement', 'globalCompanyManagement', 'globalCompanyManagementView']"
							></app-data-set-table-menu>
						}
					</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
				<tr
					mat-row
					*matRowDef="let row; columns: displayedColumns"
					(appDataSetRowClick)="onRowClick(row)"
					[attr.data-automation-id]="'public-directory-' + row.id + '-row'"
				></tr>
			</table>

			<mat-menu #menu="matMenu">
				<ng-template matMenuContent let-row="row">
					@if (hasGcmView) {
						<button
							mat-menu-item
							(click)="onRowClick(row)"
							i18n="@@publicDirectory-viewCompany"
							data-automation-id="view-company-button"
						>
							View Company
						</button>
					}
					@if (!isCompanyInMyCompaniesList(row.id) && canAddToMyCompanies) {
						<button
							mat-menu-item
							(click)="navigateToAddCompanyById(row)"
							i18n="@@publicDirectory-addToMyCompaniesList"
							data-automation-id="add-to-company-list-button"
						>
							Add To My Companies List
						</button>
					}
				</ng-template>
			</mat-menu>
		</app-data-set-table-view>
	</app-data-set-content>
</app-data-set>
